import { render, staticRenderFns } from "./WaterCrossingDetails.vue?vue&type=template&id=e27ceaa4"
import script from "./WaterCrossingDetails.vue?vue&type=script&lang=js"
export * from "./WaterCrossingDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports